/**
 * @file AGE: the whole calendar days from an invoice's due date to the period's
 * `to`, each read as its local day in the calendar time zone, floored at zero.
 * Consumer: the Invoicing tab's invoice rows. The due date is the served
 * `invoiceDueDate` cell, a SQL timestamp with an offset. Counting local days
 * is the day boundary `agingStarts` uses in
 * `cloud_run/analytics/src/serving/resolveCalendarBound.ts`, so AGE 60 sits in
 * the 31 to 60 bucket and AGE 61 in the 61 to 90 one, whatever the stored time.
 */
import { DateTime } from 'luxon';

const localDay = (instant: DateTime): DateTime =>
  DateTime.fromISO(instant.toISODate() ?? '', { zone: 'utc' });

export const analyticsDaysPastDue = (
  invoiceDueDate: string,
  to: string,
  timeZone: string,
): number => {
  const due = localDay(DateTime.fromSQL(invoiceDueDate, { zone: timeZone }));
  const end = localDay(DateTime.fromISO(to, { zone: timeZone }));
  return Math.max(end.diff(due, 'days').days, 0);
};
